'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Const


var _validationConstants = require('../../validationConstants');

// Writing our own isValid function based on the MongoDB driver version to reduce file size as this will also
// be included on the client
var checkForHexRegExp = new RegExp('^[0-9a-fA-F]{24}$');
var isObjectIdValid = function isObjectIdValid(id) {
    if (id === null) return false;

    if (typeof id === 'number') {
        return true;
    }

    if (typeof id === 'string') {
        return id.length === 12 || id.length === 24 && checkForHexRegExp.test(id);
    }

    return false;
};

var EMAIL_ERROR_OBJECT = {
    name: _validationConstants.FAILURE_NAMES.objectId,
    type: _validationConstants.FAILURE_TYPES.ERROR,
    message: 'Not a valid objectId'
};

var getErrorObject = function getErrorObject(fieldValue) {
    return _extends({}, EMAIL_ERROR_OBJECT, {
        value: fieldValue
    });
};

exports.default = function (fieldValue) {
    if (!fieldValue) return null;
    if (!isObjectIdValid(fieldValue)) return getErrorObject(fieldValue);
    return null;
};


//////////////////
// WEBPACK FOOTER
// ./src/common/validation/validators/type/objectIdValidator.js
// module id = 2306
// module chunks = 0